import { Injectable } from '@angular/core';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { InfoModalComponent } from '../info-modal/info-modal.component';
import { ViolationsModalComponent } from '../../shipment/violations-modal/violations-modal.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmService {

    constructor(private dialog: MatDialog) {
    }

    public action(title: string, text: string, yesCaption: string, action: () => void): void {
        this.dialog.open(ConfirmModalComponent, { data: { title, text, yesCaption, noCaption: $localize`Cancel`, action }});
    }

    public confirm(title: string, text: string, action: () => void): void {
        this.dialog.open(ConfirmModalComponent, { data: { title, text, action }});
    }

    public information(title: string, text: string, action: () => void = null): void {
        this.dialog.open(InfoModalComponent, { data: { title, text, action }});
    }

    public showViolations(): void {
        this.dialog.open(ViolationsModalComponent);
    }

}
